<template>

  <vs-table :data="ptos">

    <template slot="thead">
      <vs-th :key="i" class="text-base" v-for="(title, i) in header"
             :class="{'float-right': title === $t('ptos.table.actions')}">{{ title }}</vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :data="tr" :key="indexTr" v-for="(tr, indexTr) in data">
        <vs-td :data="tr.user.name">
          {{ tr.user.name }}
        </vs-td>
        <vs-td :data="tr.user.surname">
          {{ tr.user.surname }}
        </vs-td>
        <vs-td :data="tr.start_date">
          {{ tr.start_date | date('MMM Do YYYY') }}
        </vs-td>
        <vs-td :data="tr.end_date">
          {{ tr.end_date | date('MMM Do YYYY') }}
        </vs-td>
        <vs-td :data="tr.status">
          {{ tr.status | ptoStatus }}
        </vs-td>
        <vs-td class="text-right w-16">
          <div class="flex justify-end">
            <vx-tooltip :text="$t('buttons.details')" position="top">
              <base-button @click="$emit('details', tr)" class="self-end mx-px" icon="info"></base-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('buttons.approve')" position="top">
              <base-button :disabled="!tr.can_approve" :loading="isUpdating(tr.id)" @click="approve(tr)"
                           class="self-end mx-px" icon="check"></base-button>
            </vx-tooltip>
            <vx-tooltip :text="$t('buttons.reject')" position="top">
              <base-button :disabled="!tr.can_reject" :loading="isUpdating(tr.id)" @click="reject(tr)" class="self-end mx-px"
                           color="danger" icon="ban"></base-button>
            </vx-tooltip>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
  export default {
    name: 'PtosApprovalTable',
    props: {
      header: {
        type: Array,
        required: true
      },
      ptos: {
        type: Array,
        required: true
      },
      updatingPtos: {
        type: Array,
        default: () => ([])
      }
    },
    methods: {
      isUpdating (id) {
        return this.updatingPtos.indexOf(id) > -1
      },
      approve (tr) {
        this.updatingPtos.push(tr.id);
        this.$emit('approve', tr);
      },
      reject (tr) {
        this.updatingPtos.push(tr.id);
        this.$emit('reject', tr);
      }
    },
  }
</script>

<style lang="scss" scoped>
</style>
